var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKeyboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    viewBox: "0 0 25 18",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: 0
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2667 0.666626H3.06669C1.74669 0.666626 0.678687 1.74663 0.678687 3.06663L0.666687 15.0666C0.666687 16.3866 1.74669 17.4666 3.06669 17.4666H22.2667C23.5867 17.4666 24.6667 16.3866 24.6667 15.0666V3.06663C24.6667 1.74663 23.5867 0.666626 22.2667 0.666626ZM11.4667 4.26663H13.8667V6.66663H11.4667V4.26663ZM11.4667 7.86663H13.8667V10.2666H11.4667V7.86663ZM7.86669 4.26663H10.2667V6.66663H7.86669V4.26663ZM7.86669 7.86663H10.2667V10.2666H7.86669V7.86663ZM6.66669 10.2666H4.26669V7.86663H6.66669V10.2666ZM6.66669 6.66663H4.26669V4.26663H6.66669V6.66663ZM17.4667 15.0666H7.86669V12.6666H17.4667V15.0666ZM17.4667 10.2666H15.0667V7.86663H17.4667V10.2666ZM17.4667 6.66663H15.0667V4.26663H17.4667V6.66663ZM21.0667 10.2666H18.6667V7.86663H21.0667V10.2666ZM21.0667 6.66663H18.6667V4.26663H21.0667V6.66663Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboard);
export default __webpack_public_path__ + "static/media/keyboard.41ad4476.svg";
export { ForwardRef as ReactComponent };